var Behavior = {
  HANDLE: 0,
  CONTEXT: 1
};
var Constants = {
  Behavior: Behavior
};

export { Behavior, Constants as default };
